export const static_data_totals = {
  "un": 193,
  "unp": 256,
  "tcc": 330,
  "reg": 1121,
  "reg_no": {
    "AE": 7,
    "AF": 5,
    "AG": 2,
    "AO": 6,
    "AR": 24,
    "AT": 9,
    "AU": 9,
    "AZ": 3,
    "BA": 3,
    "BD": 4,
    "BE": 3,
    "BF": 4,
    "BG": 4,
    "BN": 2,
    "BO": 3,
    "BQ": 3,
    "BR": 28,
    "BW": 3,
    "BY": 3,
    "BZ": 2,
    "CA": 13,
    "CD": 5,
    "CF": 3,
    "CG": 6,
    "CH": 26,
    "CI": 4,
    "CL": 6,
    "CM": 5,
    "CN": 31,
    "CO": 6,
    "CU": 4,
    "CV": 2,
    "CZ": 4,
    "DE": 16,
    "DK": 6,
    "DZ": 5,
    "EC": 4,
    "EG": 7,
    "ES": 19,
    "ET": 12,
    "FI": 4,
    "FJ": 4,
    "FM": 4,
    "FR": 22,
    "GA": 3,
    "GB": 18,
    "GE": 2,
    "GH": 4,
    "GL": 3,
    "GN": 4,
    "GQ": 3,
    "GR": 8,
    "GT": 4,
    "GW": 2,
    "HN": 4,
    "HR": 5,
    "HU": 4,
    "ID": 13,
    "IE": 4,
    "IN": 35,
    "IQ": 5,
    "IR": 8,
    "IS": 3,
    "IT": 21,
    "JP": 10,
    "KE": 7,
    "KG": 4,
    "KI": 3,
    "KN": 2,
    "KP": 4,
    "KR": 6,
    "KZ": 6,
    "LA": 3,
    "LK": 3,
    "LY": 3,
    "MA": 8,
    "MD": 2,
    "ME": 3,
    "MG": 6,
    "ML": 2,
    "MM": 6,
    "MN": 5,
    "MR": 3,
    "MT": 2,
    "MU": 2,
    "MW": 3,
    "MX": 32,
    "MY": 5,
    "MZ": 3,
    "NA": 4,
    "NC": 3,
    "NE": 3,
    "NG": 6,
    "NL": 4,
    "NO": 5,
    "NZ": 6,
    "OM": 4,
    "PE": 9,
    "PF": 5,
    "PG": 8,
    "PH": 6,
    "PK": 7,
    "PL": 7,
    "PM": 2,
    "PT": 7,
    "PY": 4,
    "RO": 9,
    "RS": 5,
    "RU": 84,
    "SA": 5,
    "SD": 5,
    "SE": 4,
    "SH": 3,
    "SJ": 2,
    "SK": 3,
    "SL": 2,
    "SO": 2,
    "SS": 3,
    "ST": 2,
    "TD": 3,
    "TH": 6,
    "TJ": 4,
    "TL": 3,
    "TM": 3,
    "TN": 3,
    "TO": 3,
    "TR": 8,
    "TT": 2,
    "TZ": 7,
    "UA": 24,
    "UG": 4,
    "US": 51,
    "UZ": 6,
    "VC": 2,
    "VE": 8,
    "VN": 8,
    "WF": 2,
    "WS": 2,
    "YE": 3,
    "ZA": 9,
    "ZM": 5,
    "ZW": 3
  }
};
